/* eslint-disable react/require-default-props */
import React from 'react'
import { createUseStyles, useTheme } from 'react-jss'
import { useWindowResize } from '../../../hooks/useWindowSize'
import breakpoints from '../../../theme/breakpoints'

type RuleNames = 'container'

interface StyleProps {
    gridTemplateColumns?: string
}

type Props = {
    gridTemplateColumns?: string
}

const useStyles = createUseStyles<RuleNames, StyleProps, Jss.Theme>(() => ({
    container: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        gridGap: '1.5rem',
        maxWidth: '100%',
        [`@media (min-width: ${breakpoints.Desktop}px)`]: {
            '&': {
                display: 'grid',
                gridTemplateColumns:
                    'minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)',
            },
        },
    },
}))

const CardColumnContainer: React.FC<Props> = ({
    gridTemplateColumns,
    children,
}) => {
    const windowSize = useWindowResize()
    const theme = useTheme<Jss.Theme>()
    const classes = useStyles({ ...{ gridTemplateColumns }, theme })

    // if (windowSize.width >= breakpoints.Desktop) {
    //     return <div className={classes.container}>{children}</div>
    // }

    return <div className={classes.container}>{children}</div>
}

export { CardColumnContainer }
